import React from 'react';
import { TextField, Grid, Fab, Input, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { inputFieldNames } from '../../../constants';
import { DatePicker } from '../../DatePicker';
import { utcToLocal } from '../../../utils/timeConverter';

import { Attachment as AttachmentIcon } from '@material-ui/icons';
import CardAttachments from '../../CardAttachments';

const useStyles = makeStyles((theme) => ({
  addControlContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  header: {
    paddingBottom: theme.spacing(1)
  },
  formContainer: {
    paddingBottom: theme.spacing(2)
  },
  addAttachmentFab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 210,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const AddHazardManagementLog = (props) => {
  const classes = useStyles();
  const {
    managementLog,
    handleInputChange,
    handleSubmitManagementLog,
    actionButtonText = 'Add',
    handleRemoveAttachment,
    allAttachments
  } = props;

  const hiddenFileInput = React.createRef();

  const handleClick = (event) => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const newObj = {
      newlyAdded: true,
      removed: false,
      fileData: file,
      name: file.name
    };
    handleInputChange(
      newObj,
      inputFieldNames.HAZARD_MANAGEMENT_LOGS_ATTACHMENT
    );
    hiddenFileInput.current.children[0].value = null;
  };

  return (
    <Grid container spacing={3} className={classes.formContainer}>
      <Grid item xs={12}>
        <TextField
          id="controlComments"
          label="Description"
          onChange={(e) => handleInputChange(e, inputFieldNames.LOG_DESCRIPION)}
          value={managementLog.description}
          fullWidth={true}
          multiline
          rows={2}
          variant="outlined"
        />
      </Grid>

      <Grid item xs={6}>
        <DatePicker
          id="injuryDate"
          htmlId="injuryDate"
          title="Log Date"
          className={classes.picker}
          handleDateChange={(date) =>
            handleInputChange(date, inputFieldNames.LOG_DATE)
          }
          selectedDate={
            actionButtonText === 'Add'
              ? managementLog.logDate
              : utcToLocal(managementLog.logDate)
          }
          required={true}
        />
      </Grid>
      <Grid item xs={6}></Grid>

      {/***************** Attachment ******************/}
      <Grid item xs={12} className={classes.gridItem}>
        <Typography className={classes.label}>Attachments</Typography>
      </Grid>
      <Grid item xs={12} className={classes.gridItem}>
        <Fab
          id="addAttachmentBtn"
          color="primary"
          variant="extended"
          aria-label="add"
          onClick={handleClick}
          className={`${classes.addAttachmentFab} ${classes.button}`}
        >
          <AttachmentIcon className={classes.extendedIcon} />
          Add attachment
          <Input
            type="file"
            ref={hiddenFileInput}
            multiple={false}
            onChange={onAttachmendAdded}
            style={{ display: 'none' }}
          />
        </Fab>
      </Grid>
      {allAttachments && (
        <Grid item xs={12} className={classes.gridItem}>
          <CardAttachments
            allAttachments={allAttachments}
            onRemoveAttachment={handleRemoveAttachment}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AddHazardManagementLog;
